import { setOrderReturn } from "@/services";
import { toastError, toastSuccess } from "@/utils";
import { Toast } from "primereact";
import { useMutation, useQueryClient } from "react-query";

export const useSetOrderReturnData = (toast: React.RefObject<Toast>) => {
 const queryClient = useQueryClient();
 const { mutate: returnMutate } = useMutation(
  async (orderId: bigint) => await setOrderReturn(orderId),
  {
   onSuccess: () => {
    queryClient.invalidateQueries("orders");
    toastSuccess(toast, "Order set return.");
   },
   onError: () => {
    toastError(toast, "Order not set return.");
   },
  },
 );
 return {
  returnMutate,
 };
};
